import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import SignedInLinks from './SignedInLinks'
import SignedOutLinks from './SignedOutLinks'
import { connect } from 'react-redux'


class Navbar extends Component {

  constructor (props){
     super(props);
     this.state = {
      count:0
    }
  }

  componentDidMount(){    
    if(document.getElementById("linkDiv") && document.getElementById("changeWidth")){
      var newWidth = document.getElementById("linkDiv").offsetWidth.toString() + "px";
      document.getElementById("changeWidth").style.width = newWidth;
    }
    if(this.props.messages !== undefined && this.props.reviewMessages !== undefined
      && this.props.issueMessages !== undefined){
        var count = 0;
        for(var key in this.props.reviewMessages){
          if(this.props.reviewMessages[key] !== null){
            count = count+1;
          }
        }
        for(var key in this.props.messages){
          if(this.props.messages[key] !== null){
            count = count+1;
          }
        }
        for(var key in this.props.issueMessages){
          if(this.props.issueMessages[key] !== null){
            count = count+1;
          }
        }
       if(this.state.count !== count){
        this.setState({count:count})
       } 
      }
  }

  componentDidUpdate(){
    if(document.getElementById("linkDiv") && document.getElementById("changeWidth")){
      var newWidth = document.getElementById("linkDiv").offsetWidth.toString() + "px";
      document.getElementById("changeWidth").style.width = newWidth;
    }
    if(this.props.messages !== undefined && this.props.reviewMessages !== undefined
      && this.props.issueMessages !== undefined){
        var count = 0;
        for(var key in this.props.reviewMessages){
          if(this.props.reviewMessages[key] !== null){
            count = count+1;
          }
        }
        for(var key in this.props.messages){
          if(this.props.messages[key] !== null){
            count = count+1;
          }
        }
        for(var key in this.props.issueMessages){
          if(this.props.issueMessages[key] !== null){
            count = count+1;
          }
        }
       if(this.state.count !== count){
        this.setState({count:count})
       } 
      }
  }

scrollToTop(){
  if(window.location.pathname === '/'){
    window.scrollTo(0, 0);  
  }
}

render(){
  const { auth, user, points } = this.props;
  // console.log(auth);
  const links = auth.uid && user ? <SignedInLinks count={this.state.count} profile={user} auth={auth} points={points} /> : <SignedOutLinks />;
  
  //document.getElementById("changeWidth").width = document.getElementById("linkDiv").width;

  return (
    <div className="topNav">
    <nav className="testNav">
      <div className="flexNav">
        <div id = "changeWidth">
        </div>
        <div>
          <NavLink onClick={this.scrollToTop} to='/' className="title">kilRVA</NavLink>
        </div>
        <div className="userPage" style={{"display":"flex","flexFlow":"row"}} id="linkDiv">
          {links}
        </div>
      </div>
    </nav>
    
    </div>
  )
}
}

const mapStateToProps = (state) => {
  // console.log(state);
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return{
    auth: state.firebase.auth,
    points: state.firestore.data.points,
    messages: state.firestore.data.messages,
    reviewMessages: state.firestore.data.reviewMessages,
    issueMessages: state.firestore.data.issueMessages,
    user
  }
}

export default connect(mapStateToProps)(Navbar)
